import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const NoteWrap = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const NoteHeading = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  fontWeight: 600,
  lineHeight: 1.4,
  marginBottom: theme.spacing(0.25),
}));

const NoteList = styled("ul")(({ theme }) => ({
  margin: 0,
  paddingLeft: theme.spacing(2.25),
  "& li": {
    fontSize: "0.875rem",
    lineHeight: 1.5,
    marginBottom: theme.spacing(0.25),
  },
}));

export default function Note({ heading, value }) {
  const values = value.trim().split("\\n").map((x) => x.trim()).filter(Boolean);
  return (
    <NoteWrap>
      <NoteHeading component="h4">{heading}</NoteHeading>
      <NoteList>
        {values.map((val, i) => <li key={i}>{val}</li>)}
      </NoteList>
    </NoteWrap>
  );
}

Note.propTypes = {
  heading: PropTypes.string,
  value: PropTypes.string,
};
